import { StoryblokTemplateWrapper as StoryblokTemplate } from "./StoryblokTemplate";

export { StoryblokTemplate };
